import { render, staticRenderFns } from "./report-header-row.vue?vue&type=template&id=66d8c23a&scoped=true"
import script from "./report-header-row.vue?vue&type=script&lang=js"
export * from "./report-header-row.vue?vue&type=script&lang=js"
import style0 from "./report-header-row.vue?vue&type=style&index=0&id=66d8c23a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d8c23a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ReportOrdersSearch: require('/home/runner/work/foaps-v2/foaps-v2/components/report/report-orders-search.vue').default,ReportOrderFilter: require('/home/runner/work/foaps-v2/foaps-v2/components/report/report-order-filter.vue').default,ReportHeaderOutletSelector: require('/home/runner/work/foaps-v2/foaps-v2/components/report/report-header-outlet-selector.vue').default,ReportHeaderChannelSelector: require('/home/runner/work/foaps-v2/foaps-v2/components/report/report-header-channel-selector.vue').default,ReportItemWiseSalesDisplayCategorySwitch: require('/home/runner/work/foaps-v2/foaps-v2/components/report/report-item-wise-sales-display-category-switch.vue').default,ReportHeaderDateRangeSelector: require('/home/runner/work/foaps-v2/foaps-v2/components/report/report-header-date-range-selector.vue').default,ReportDownload: require('/home/runner/work/foaps-v2/foaps-v2/components/report/report-download.vue').default,ReportPrint: require('/home/runner/work/foaps-v2/foaps-v2/components/report/report-print.vue').default})
